import { BaseModel } from "./base-model";

export interface IBaseTranslation {
  Id?: number;
  ParentId?: number;
  IconUrl?: string;
  NameNL?: string;
  NameFR?: string;
  NameEN?: string;

}
export class BaseTranslation extends BaseModel<IBaseTranslation> implements IBaseTranslation {
  Id?: number;
  ParentId?: number;
  IconUrl?: string;
  NameNL?: string;
  NameFR?: string;
  NameEN?: string;
  /**
   *
   */
  constructor(option: IBaseTranslation) {
    super(option)
  }
}